export const DETAILS_POUP_TABS = {
  GENERAL: 'general',
  PRODUCT_PORTFOLIO: 'product-portfolio',
  FINANCIALS: 'financials',
  SHAREHOLDER_STRUCTURE: 'shareholder-structure',
  BANKS: 'banks',
  KEY_CONTACTS: 'key-contacts',
  SIMILAR_COMPANIES: 'similar-companies',
  UPDATES: 'updates'
};
